import { Component, OnInit, ElementRef ,ViewChild } from '@angular/core';
import { DayAgoPipe } from 'src/app/shared/day-ago.pipe';
import {  Router } from '@angular/router';
import { AngularFireStorage } from '@angular/fire/storage';
import { AuthService } from 'src/app/auth/auth.service';
import { UserDataService } from 'src/app/features/user-data.service';
import { MailCenterService } from 'src/app/mail-center/mail-center.service';
import { first } from 'rxjs/operators';
import jsPDF from 'jspdf';

import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image';
@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {
  status:string=""; //deciding the shown material
  statusList:any;//list of the status records
  keyCode:any;
  inventionDetailData!:any;
  companyData:any; inventorData:any;attorneyData:any; rdCenter:any;project:any;
  visible=false;
  visibleSummary=false;
  visibleDocuments=false;
  visibleTimeLimits=false;
  visibleDecision=false;
  visibleRecord=false;
  visiblePatents=false;
  visibleInventorAgreement=false;
  visibleNotes=false;
  visibleForms=false;
  visibleUlkeCikisFormu=false;
  visibleHakTalebiFormu=false;
  visibleBulusBildirimFormu=false;
  value="";
  docType="";

  inventionName:any;
  documentNumber:any;
  inventionDate:any;
  path="";
  myRadio="";
  valid=false;
  fileName="";
  isFolderLoaded=false;
  isStatusUpdated=false;
  errorCode="";
  error=false;
  errorText:string=""
  errorText1:string=""
  errorText2:string=""
  docLink:any=[];
  docExists=false;
  notes:any;
  patentInfo:any;
  toggle=false;
  foldertoggle=false;
  otherForm=false;
  firebaseStorageLink:string="https://firebasestorage.googleapis.com/v0/b/patent-book.appspot.com/o/";
  firebaseStorageLink2:string="?alt=media&token=6c29c21e-dde6-4d0e-8f31-f163afbfdfa8";
  //firebaseStorageLink2:string="?alt=media&token=6c29c21e-dde6-4d0e-8f31-f163afbfdfa8"; Old
  //firebaseStorageLink:string="https://firebasestorage.googleapis.com/v0/b/sisecam-a8421.appspot.com/o/"; Old
  loggedUser="";
  //Inventor Agreement Form
  agreement=false;
  isAccepted=false;
  isPatentEnterenceAccepted=false;
  IAFinventorName:any;
  IAFinventorAdress:any;
  IAFinventorsCompanyName:any;
  IAFinventorsCompanyAdress:any;
  IAFinventorsPatentCountry:any;
  IAFinventorsPatentNumber:any;
  oneDay = 24*60*60*1000;

  IAFinventionDateOneDay:any;
  IAFinventionDateOneDayFormatted:any;
  IAFinventionDateOneMonth:any;
  IAFinventionDateOneMonthFormatted:any;
  visibleInventorButton=false;
randomNumber=1;

formPatentNumber="";
formPatentDate="";
CompanyDataName:any=[];
message="";
url: any; //Angular 11, for stricter type
msg = "";


	//selectFile(event) { //Angular 8
	selectFile(event: any) { //Angular 11, for stricter type
		if(!event.target.files[0] || event.target.files[0].length == 0) {
			this.msg = 'You must select an image';
			return;
		}

		var mimeType = event.target.files[0].type;

		if (mimeType.match(/image\/*/) == null) {
			this.msg = "Only images are supported";
			return;
		}

		var reader = new FileReader();
		reader.readAsDataURL(event.target.files[0]);

		reader.onload = (_event) => {
			this.msg = "";
			this.url = reader.result;
		}
	}
  constructor(private userData:UserDataService, private auth:AuthService,  private route:Router, private af:AngularFireStorage,private mailService:MailCenterService) { }


   ngOnInit(): void {
    this.loggedUser=this.auth.userMail;
  //  this.token=this.auth.token;
  }

  ngAfterContentInit(){
    this.randomNumber=Math.floor((Math.random() * 100000) + 1);
    console.log(this.randomNumber);
    this.keyCode=this.userData.key;
    this.visibleSummary=true;
    this.userData.inventionDetail(this.keyCode).
    subscribe(res=>
      {//console.log(res);
      this.inventionDetailData=res;
      this.companyData=this.inventionDetailData[0].CompanyData;
      this.companyData?.forEach((element:any) =>
      {this.CompanyDataName.push(element.name.replace(/[&\t/\\#,+()$~%.'":*?<>{}]/g, ''));



       });
       console.log(this.CompanyDataName);
      this.attorneyData=this.inventionDetailData[0].AttorneyData;
      this.rdCenter=this.inventionDetailData[0].rdCenter;
      this.project=this.inventionDetailData[0].projectDetail;
      this.inventorData=this.inventionDetailData[0].inventorData;
      this.status=this.inventionDetailData[0].status.slice(-1)[0].status;
      this.statusList=this.inventionDetailData[0].status;
      this.inventionName=this.inventionDetailData[0].inventionName;
      this.documentNumber=this.inventionDetailData[0].documentNumber;
      this.inventionDate=this.inventionDetailData[0].inventionDate;
      this.docLink=this.inventionDetailData[0].hasOwnProperty('docLink') ? this.docLink= this.inventionDetailData[0].docLink : this.docLink=[];
      this.visible=true;

      this.inventionDetailData[0].hasOwnProperty('patentInfo') ? this.patentInfo= this.inventionDetailData[0].patentInfo : this.patentInfo=[];
      this.formPatentNumber=this.patentInfo[0]?.patentNumber;
      this.formPatentDate=this.patentInfo[0]?.patentDate;

      this.notes=this.inventionDetailData[0].hasOwnProperty('notes') ? this.notes= this.inventionDetailData[0].notes : this.notes="not yok";
      this.inventionDetailData[0].hasOwnProperty('patentInfo') ? this.agreement=true : this.agreement=false;
      this.statusList.length>1 ? this.isAccepted=true: this.isAccepted=false;
      console.log(this.statusList.slice(-1)[0].status);
      console.log(this.statusList.slice(-1)[0].status.includes("karar"));
      this.statusList.slice(-1)[0].status.includes("karar") ? this.isPatentEnterenceAccepted=true: this.isPatentEnterenceAccepted=false;
      //console.log(this.companyData);
      //console.log(this.statusList);
      })
      }

      createAgreement(i:any) {
        this.visibleInventorAgreement=!this.visibleInventorAgreement;
        for (let element of this.patentInfo) {
          if (element.patentType=='Rüçhan'){
            this.IAFinventorName=this.inventorData[i].name;
            this.IAFinventorsCompanyName=this.inventorData[i].inventorsCompany;
            this.IAFinventorsCompanyAdress=this.inventorData[i].inventorsCompanyAdress;
            this.IAFinventorAdress=this.inventorData[i].adress;
            this.IAFinventorsPatentCountry=element.patentCountry;
            this.IAFinventorsPatentNumber=element.patentNumber;
            this.IAFinventionDateOneDay=new Date( new Date(this.inventionDate).getTime()+this.oneDay);
            this.IAFinventionDateOneDayFormatted=this.IAFinventionDateOneDay.getFullYear() + "-";

            if (this.IAFinventionDateOneDay.getMonth() < 9) {
              this.IAFinventionDateOneDayFormatted += "0";
            }
            this.IAFinventionDateOneDayFormatted += (this.IAFinventionDateOneDay.getMonth() + 1);
            this.IAFinventionDateOneDayFormatted += "-";

            if(this.IAFinventionDateOneDay.getDate() < 10) {
              this.IAFinventionDateOneDayFormatted += "0";
            }
            this.IAFinventionDateOneDayFormatted += this.IAFinventionDateOneDay.getDate();
         ////////////One month
          this.IAFinventionDateOneMonth=new Date( new Date(this.inventionDate).getTime()+this.oneDay*31);
          this.IAFinventionDateOneMonthFormatted=this.IAFinventionDateOneMonth.getFullYear() + "-";

          if (this.IAFinventionDateOneMonth.getMonth() < 9) {
            this.IAFinventionDateOneMonthFormatted += "0";
          }
          this.IAFinventionDateOneMonthFormatted += (this.IAFinventionDateOneMonth.getMonth() + 1);
          this.IAFinventionDateOneMonthFormatted += "-";

          if(this.IAFinventionDateOneMonth.getDate() < 10) {
            this.IAFinventionDateOneMonthFormatted += "0";
          }
          this.IAFinventionDateOneMonthFormatted += this.IAFinventionDateOneMonth.getDate();
        //console.log(this.IAFinventionDateOneMonthFormatted);


          break;
        } else {console.log(".");}
        }
      }




    getDetails() {
      this.keyCode=this.userData.key;
      this.visibleSummary=true;
      this.userData.inventionDetail(this.keyCode).
      subscribe(res=>
        {//console.log(res);
        this.inventionDetailData=res;
        this.companyData=this.inventionDetailData[0].CompanyData;

        this.inventorData=this.inventionDetailData[0].inventorData;
        this.attorneyData=this.inventionDetailData[0].AttorneyData;
        this.status=this.inventionDetailData[0].status.slice(-1)[0].status;
        this.statusList=this.inventionDetailData[0].status;
        this.inventionName=this.inventionDetailData[0].inventionName;
        this.documentNumber=this.inventionDetailData[0].documentNumber;
        this.inventionDate=this.inventionDetailData[0].inventionDate;
        this.docLink=this.inventionDetailData[0].hasOwnProperty('docLink') ? this.docLink= this.inventionDetailData[0].docLink : this.docLink=[];
        this.visible=true;
        this.patentInfo=this.inventionDetailData[0].hasOwnProperty('patentInfo') ? this.patentInfo= this.inventionDetailData[0].patentInfo : this.patentInfo=[];
        //console.log(this.companyData);
        //console.log(this.statusList);
        })
      }
    summary(){
      this.visibleSummary=true;
      this.visibleDocuments=false;
      this.visibleTimeLimits=false;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=false;
      this.visibleInventorAgreement=false;
      this.visibleInventorButton=false;
      this.visibleNotes=false;
      this.visibleForms=false;
    }

    documents(){
      this.visibleSummary=false;
      this.visibleDocuments=true;
      this.visibleTimeLimits=false;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=false;
      this.visibleInventorAgreement=false;
      this.visibleInventorButton=false;
      this.visibleNotes=false;
      this.visibleForms=false;
    }
    timeLimits(){
      this.visibleSummary=false;
      this.visibleDocuments=false;
      this.visibleTimeLimits=true;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=false;
      this.visibleInventorAgreement=false;
      this.visibleInventorButton=false;
      this.visibleNotes=false;
      this.visibleForms=false;
    }
    decision(){
      this.visibleSummary=false;
      this.visibleDocuments=false;
      this.visibleTimeLimits=false;
      this.visibleDecision=true;
      this.visibleRecord=false;
      this.visiblePatents=false;
      this.visibleInventorAgreement=false;
      this.visibleInventorButton=false;
      this.visibleNotes=false;
      this.visibleForms=false;
    }
    patentRecords() {
      this.visibleSummary=false;
      this.visibleDocuments=false;
      this.visibleTimeLimits=false;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=true;
      this.visibleInventorAgreement=false;
      this.visibleInventorButton=false;
      this.visibleNotes=false;
      this.visibleForms=false;
    }
    inventorAgreements() {
      this.visibleSummary=false;
      this.visibleDocuments=false;
      this.visibleTimeLimits=false;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=false;
      this.visibleInventorAgreement=false;
      this.visibleInventorButton=true;
      this.visibleNotes=false;
      this.visibleForms=false;
    }
    addNote() {
      this.visibleSummary=false;
      this.visibleDocuments=false;
      this.visibleTimeLimits=false;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=false;
      this.visibleInventorAgreement=false;
      this.visibleInventorButton=false;
      this.visibleNotes=true;
      this.visibleForms=false;
    }
    forms() {
      this.visibleSummary=false;
      this.visibleDocuments=false;
      this.visibleTimeLimits=false;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=false;
      this.visibleInventorAgreement=false;
      this.visibleInventorButton=false;
      this.visibleNotes=false;
      this.visibleForms=true;
    }
    ulkeCikisFormu() {
    this.visibleUlkeCikisFormu=true;
    this.visibleHakTalebiFormu=false;
    this.visibleBulusBildirimFormu=false;
    }
    hakTalebiFormu() {
      this.visibleUlkeCikisFormu=false;
      this.visibleHakTalebiFormu=true;
      this.visibleBulusBildirimFormu=false;
    }
    bulusBildirimFormu(){
      this.visibleUlkeCikisFormu=false;
      this.visibleHakTalebiFormu=false;
      this.visibleBulusBildirimFormu=true;
    }
    recordTheInvention() {

      this.route.navigate(['patentList/',this.inventionDetailData[0].documentNumber,'recordInvention']);
      this.userData.getKey(this.keyCode);
    }
    recordPatent() {
      this.route.navigate(['patentList/',this.inventionDetailData[0].documentNumber,'recordPatent']);
      this.userData.getKey(this.keyCode);
    }
    recordNote(){
      this.visibleNotes=false;
      this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,
        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,
        this.notes
        ).
        subscribe(arr=>{console.log(arr);
        this.errorText2="Not Kaydedildi!";
        alert("Not kaydedildi!");
      },
        err=>{
        this.errorText1 = err.statusText;
        alert("Not KAYDEDİLEMEDİ!");
        console.log(this.error)});
    }

    updateStatus(){
      //console.log(this.value);
      this.isStatusUpdated=true;
      this.onToggle();

      this.value=(this.value.slice(this.value. length - 1))
      //console.log(this.value);
      switch(this.value) {
        case "1":
          this.value="karar:buluş iptal edildi."
          break;
        case "2":
          this.value="karar:buluş hakları buluş sahibine verildi."
          break;
        case "3":
          this.value="karar:buluş gizli tutulacaktır."
          break;
        case "4":
          this.value="karar:buluş hakları şirkete verildi"
          break;
      }
      this.statusList.push({status:this.value, date:Date.now(), recordigUser:this.loggedUser });
      //console.log(this.statusList)
      this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,

        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,
        this.notes
        ).
        subscribe(arr=>{console.log(arr);
        this.errorText1="Buluş Durumu Güncellendi!";
        alert("Buluş Durumu Güncellendi!")},
        err=>{
        this.errorText1 = err.statusText;
        console.log(this.error)});

    }
    updateStatusSendEmail() {
      const time=(Math.round((Date.now()/1000)+300)); //300 for delay
      this.isStatusUpdated=true;
      this.onToggle();
      this.value=(this.value.slice(this.value. length - 1))
      //console.log(this.value);
      switch(this.value) {
        case "1":
          this.value="karar:buluş iptal edildi."
          break;
        case "2":
          this.value="karar:buluş hakları buluş sahibine verildi."
          break;
        case "3":
          this.value="karar:buluş gizli tutulacaktır."
          break;
        case "4":
          this.value="karar:buluş hakları şirkete verildi"
          break;
      }
      this.statusList.push({status:this.value, date:Date.now(), recordigUser:this.loggedUser});
      //console.log(this.statusList)
      this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,
        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,
        this.notes
        ).
        subscribe(arr=>{console.log(arr);
        this.errorText1="Buluş Durumu Güncellendi!";
        alert("Buluş Durumu Güncellendi!")},
        err=>{
        this.errorText1 = "Yetkiniz bulunmamaktadır";
        alert("Güncelleme Yetkiniz bulunmamaktadır")
        console.log(this.error)});
        for (var val of this.inventorData) {
          let shareText=""
          if (val.share<1) {shareText="henüz belirlenmemiştir." } else {shareText=val.share+"/100"}
          this.mailService.sendStatusUpdate(val.name, this.inventionName, this.status, val.share,val.mail,time)
          .pipe(first())
          .subscribe(resp => {
          //  console.log({ resp });
          }, err => {
           // console.error({ err });
          });
        }
    }
    uplodFolder(){
    //  console.log(this.docLink);
      this.error=true;
     this.valid=true;
      this.errorText="";

      this.af.upload("files/"+this.documentNumber+"/"+this.myRadio+"/"+this.fileName+"/"+this.randomNumber,this.path);
      this.docLink.push({link:this.firebaseStorageLink+"files%2F"+this.documentNumber+"%2F"+this.myRadio+"%2F"+this.fileName+"%2F"+this.randomNumber+this.firebaseStorageLink2,date:Date.now(),docName:this.fileName, type:this.myRadio});
      this.onFolderToggle();

      this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,
        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,
        this.notes
        ).
        subscribe(arr=>{
          //console.log(arr);
          this.errorText="Dosya Yüklenmiştir";
          alert("Dosya Yüklenmiştir")},
        err=>{
        this.errorText=err.statusText;
        alert("Dosya YÜKELENEMEDİ!")
        console.log(this.errorText)});


    }

    deleteFolder(i:number){


      if(confirm(this.inventionName+" buluşuna ait dosya silinsin mi?")){
        this.onFolderToggle();
      this.userData.deletionRecords([this.loggedUser,Date.now()],'Dosya kaydı silindi', `Dosyanın silindiği buluş : ${this.inventionName} `).subscribe();
      this.af.refFromURL(this.docLink[i].link).delete();
      this.docLink.splice(i, 1);
   //   console.log(this.docLink);
      this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,
        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,
        this.notes
        ).
        subscribe(arr=>{
          //console.log(arr);
          this.errorText="Dosya silinmiştir"
          alert("Dosya silinmiştir")},
        err=>{
          this.errorText=err.statusText;
          alert("Dosya SİLİNEMEDİ!")
          console.log(this.errorText)});;

    }}
    deletePatent(i:number){
      if(confirm(this.inventionName+" buluşundaki "+ this.patentInfo[i].patentCountry+ " ülke girişi silinsin mi?")){
     // console.log(this.patentInfo[i].patentCountry);
     this.userData.deletionRecords([this.loggedUser,Date.now()],'Ülke kaydı silindi', `Silinen Ülke: ${this.patentInfo[i].patentCountry} - Dosya No:${this.documentNumber} - Buluş Adı:${this.inventionName}`).subscribe();

     // this.af.refFromURL(this.docLink[i]?.link).delete(); NEEDS FİX
      this.patentInfo.splice(i, 1);
     // console.log(this.patentInfo);
      this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,
        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,
        this.notes
        ).
        subscribe(arr=>{
          //console.log(arr);
          this.errorText="Ülke kaydı silinmiştir";

          alert("Ülke kaydı silinmiştir");},
        err=>{
          this.errorText=err.statusText;
          alert("Ülke kaydı SİLİNEMEMİŞTİR")
          console.log(this.errorText)});;

    }}
    enterCountry(i:number){
      this.userData.getItemNumber(i);
      this.route.navigate(['patentList/',this.inventionDetailData[0].documentNumber,'countryRecord',this.patentInfo[i].patentCountry]);

      this.userData.getKey(this.keyCode);
    }

    upload($event:any){
      this.path=$event.target.files[0];
      this.isFolderLoaded=($event.isTrusted);


    }
    checkDocument(){
      console.log(this.docLink);
      let iterable=false;
      this.patentInfo?.forEach((element: any) =>
      {if (element.countryDocLink) {iterable=true; console.log(element.countryDocLink)}
      else{}


       });

      if (this.docLink.length<1 && !iterable ){return false}
      else {return true}
  }
    checkCountry(){
      if (this.patentInfo?.length<1) {return false}
      else {return true}
    }
    navigate(){this.route.navigate(['patentList/']);
  this.userData.getKey(this.keyCode);}
    onToggle() {this.toggle=!this.toggle;
      this.errorText1="";}
    onFolderToggle() {this.foldertoggle=!this.foldertoggle;
      this.errorText="";}
    mailCenter() {
      this.route.navigate(['patentList/',this.inventionDetailData[0].documentNumber,'mailCenter']);
      this.userData.getKey(this.keyCode);
    }

    formName() {
      this.otherForm=true;
    }



      }


